export const TRPC_URL: string = process.env.REACT_APP_TRPC_URL as string
export const LOGGER_ENABLED: boolean = process.env.REACT_APP_LOGGER_ENABLED === 'true'
export const CDN_URL = 'https://cdn.audiocutter.online'
